import "./App.css"
import QueryBuilder from "./components/QueryBuilder"
import Navbar from "./components/Navbar"
import React, { useEffect, useState } from "react"
import Tables from "./components/Tables"
import Graphs from "./components/Graphs"
import PieCharts from "./components/Piecharts"
import CompositeSent from "./components/CompositeSent"
import { useNavigate } from "react-router-dom"
import Footer from "./components/Footer"
import { auth } from "./components/firebase"
import { useAuthState } from "react-firebase-hooks/auth"
import Joyride, { ACTIONS, EVENTS, STATUS } from "react-joyride"
import fullScreenImg from "./components/static/full_screen_HC.png"
import stocksImg from "./components/static/stocks_HC.png"
import CandlestickChartIcon from "@mui/icons-material/CandlestickChart"
import {
    Container as FContainer,
    Button as FButton
} from "react-floating-action-button"
import axios from "axios"
import api from "./components/api_ui"
import useUser from "./components/hooks/useUser"
import { Tooltip } from "@material-ui/core"

const OurApp = () => {
    const [user, loading, error] = useAuthState(auth)
    const navigate = useNavigate()
    const [queryOptions, setOptions] = useState([])
    const { currentUser } = useUser()

    // Use centralized trial user check from useUser hook
    const isTrialUser = currentUser?.isTrialUser || false

    useEffect(() => {
        if (loading) return
        if (!user) return navigate("/")
    }, [user, loading])

    const [query, setQuery] = React.useState({})
    const [savedQuery, setSavedQuery] = React.useState({})
    const [pieChartsData, setPieChartsData] = React.useState({})
    const [compositeSentimentData, setCompositeSentimentData] = React.useState(
        {}
    )
    const [newsTableData, setNewsTableData] = React.useState({
        data: { total: 0, data: [] },
        count: { positive: 0, negative: 0, neutral: 0 },
        count_text: { positive: 0, negative: 0, neutral: 0 }
    })
    const [stocktwitsTableData, setStocktwitsTableData] = React.useState({
        data: { title: { total: 0, data: [] } },
        count: { positive: 0, negative: 0, neutral: 0 },
        count_text: { positive: 0, negative: 0, neutral: 0 }
    })
    const [redditTableData, setRedditTableData] = React.useState({
        data: { title: { total: 0, data: [] } },
        count: { positive: 0, negative: 0, neutral: 0 },
        count_text: { positive: 0, negative: 0, neutral: 0 }
    })
    const [blueskyTableData, setBlueskyTableData] = React.useState({
        data: { title: { total: 0, data: [] } },
        count: { positive: 0, negative: 0, neutral: 0 },
        count_text: { positive: 0, negative: 0, neutral: 0 }
    })
    const [edgarTableData, setEdgarTableData] = React.useState({
        data: { title: { total: 0, data: [] } },
        count: { positive: 0, negative: 0, neutral: 0 },
        count_text: { positive: 0, negative: 0, neutral: 0 }
    })
    const [ticker, setTicker] = React.useState("")
    const [avHicData, setAvHicData] = React.useState([])
    const [ibmNewsHicData, setIbmNewsHicData] = React.useState([])
    const [stocktwitsHicData, setStocktwitsHicData] = React.useState([])
    const [redditHicData, setRedditHicData] = React.useState([])
    const [blueskyHicData, setBlueskyHicData] = React.useState([])
    const [edgarHicData, setEdgarHicData] = React.useState({})
    const [hicData, setHicData] = React.useState([])
    const [newsToggle, setToggle] = React.useState("title")
    const [queryModified, setModifiedState] = React.useState(false)
    const [queryMeta, setQueryMeta] = React.useState({
        name: null,
        version: null,
        sector: null,
        prevVersion: null
    })
    const [compWeights, setWeights] = useState({
        stocktwits: 0,
        news: 0,
        thirdParty: 0,
        gtrends: 0,
        edgar: 0,
        bluesky: 0
    })

    const [modalOpen, setModalOpen] = useState(false)
    const [alertsWeightage, setAlertsWeightageModalOpen] = useState(false)

    const [steps, setSteps] = useState([
        {
            target: ".main-video-step",
            content: (
                <div>
                    <span>
                        <strong>Step 1: Video Tutorials</strong>
                        <br />
                        Watch these 3 tutorials for an overview of Dashboards, Alerts, & Query and get started.
                    </span>
                </div>
            ),
            disableBeacon: true
        },
        {
            target: ".first-step",
            content: (
                <div>
                    <span>
                        <strong>Step 2: Select an Existing Query</strong>
                        <br />
                        Start by selecting an existing query from the dropdown
                        list. These queries are pre-built examples that
                        demonstrate how to analyze sentiment for specific
                        stocks, events, or market themes. For this tour, we'll
                        use a query that analyzes sentiment around Tesla's
                        addition to the S&P 500 index.
                    </span>
                </div>
            ),
            disableBeacon: true
        },

        {
            target: ".query-builder",
            content: (
                <div>
                    <span>
                        <strong>Step 3: Understanding the Query Builder</strong>
                        <br />
                        This is where you can view your selected query or create
                        a new one. The query builder allows you to define
                        specific criteria for sentiment analysis, such as
                        keywords, companies, people, or authors. You can also
                        set date ranges and choose which data sources to analyze
                        (News, Stocktwits, Reddit, etc.).
                    </span>
                </div>
            )
        },
         {
            target: ".natural-lang-querybuilder",
            content: (
                <div>
                    <span>
                        <strong>Step 3.1: Understanding the Natural language search</strong>
                        <br />
                        This is where you can search for results based on natural language. It supports AND, OR and NOT operators along with the query.
                        It is more flxible and simple than the query builder.
                    </span>
                </div>
            )
        },
        {
            target: ".third-step",
            content: (
                <div>
                    <span>
                        <strong>Step 4: Debug Panel</strong>
                        <br />
                        The Debug panel displays your query in JSON format,
                        showing exactly how your search criteria are structured.
                        This is useful for understanding the technical details
                        of your query and troubleshooting if needed.
                    </span>
                </div>
            )
        },
        {
            target: ".second-step",
            content: (
                <div>
                    <span>
                        <strong>Step 5: Query Builder Controls</strong>
                        <br />
                        Click to expand or collapse the Query Builder section.
                        When expanded, you can modify the query by adding or
                        removing search criteria, changing operators, or
                        adjusting the date range.
                    </span>
                </div>
            )
        },

        {
            target: ".fourth-step",
            content: (
                <div>
                    <span>
                        <strong>Step 6: Sentiment Analysis Options</strong>
                        <br />
                        Choose how you want to analyze sentiment. You can select
                        sentiment based on
                        <strong> News Title</strong> (faster, broader analysis)
                        or
                        <strong> News Text</strong> (more detailed,
                        comprehensive analysis). For example, analyzing Tesla's
                        S&P 500 inclusion might focus on news titles for quick
                        sentiment trends or news text for deeper insights.
                    </span>
                </div>
            )
        },
        {
            target: ".new-step-five",
            content: (
                <div>
                    <span>
                        <strong>Step 7: Data Quality (DQ) Settings</strong>
                        <br />
                        DQ filters help improve result quality by scoring social
                        media posts based on credibility and usefulness. Choose
                        between
                        <strong> DQ sentiment</strong> (filtered, higher
                        quality) or
                        <strong> Non-DQ sentiment</strong> (unfiltered, more
                        comprehensive). For Tesla analysis, DQ might filter out
                        low-quality social media noise.
                    </span>
                </div>
            )
        },
        {
            target: ".fifth-step",
            content: (
                <div>
                    <span>
                        <strong>Step 8: Execute Your Query</strong>
                        <br />
                        Click this button to run your query and analyze
                        sentiment data. The system will process news articles,
                        social media posts, and other sources to provide
                        sentiment insights for your selected criteria.
                    </span>
                </div>
            )
        },
        {
            target: ".query-results",
            content: (
                <div>
                    <span>
                        <strong>Step 8.1: View Query Results</strong>
                        <br />
                        After running your query, you'll see the sentiment
                        analysis results here. The system analyzes documents
                        from multiple sources and provides aggregated sentiment
                        scores, trends, and individual document listings. This
                        gives you actionable insights for your investment
                        decisions.
                    </span>
                </div>
            )
        },
        {
            target: ".interpretation-help",
            content: (
                <div>
                    <span>
                        <strong>Step 8.2: Understanding Your Results</strong>
                        <br />
                        <strong>Sentiment Scores:</strong> Positive values
                        indicate bullish sentiment, negative values indicate
                        bearish sentiment. Values range from -1 to +1.
                        <br />
                        <strong>Volume:</strong> Higher volume means more
                        discussion about the topic.
                        <br />
                        <strong>Trends:</strong> Look for changes in sentiment
                        over time to identify shifts in market perception.
                        <br />
                        <strong>Sources:</strong> Different sources (News,
                        Social Media) may show different sentiment patterns.
                    </span>
                </div>
            )
        },
        {
            target: ".new-step-one",
            content: (
                <div>
                    <span>
                        <strong>Step 9: Configure Screen Layout</strong>
                        <br />
                        Customize your dashboard by choosing which panels to
                        display on the main screen. You can show/hide Composite
                        Sentiment, Pie Charts, Graphs, and Tables based on your
                        analysis needs.
                    </span>
                </div>
            )
        },
        {
            target: ".new-step-two",
            content: (
                <div>
                    <span>
                        <strong>Step 10: Set Source Weights</strong>
                        <br />
                        Configure how much importance to give each data source
                        in your sentiment analysis. This panel displays
                        Composite Sentiment from multiple sources (News,
                        Stocktwits, Reddit, etc.). You can adjust weights based
                        on which sources you trust most for your analysis.
                    </span>
                </div>
            )
        },
        {
            target: ".sixth-step",
            content: (
                <div>
                    <span>
                        <strong>Step 11: Sentiment Overview</strong>
                        <br />
                        This panel shows the aggregated sentiment view for each
                        source over your query period. Each source has its own
                        color-coded doughnut chart. The arc lengths represent
                        sentiment strength: Strong Sell (red), Weak Sell
                        (orange), Neutral/Hold (yellow), Weak Buy (light green),
                        Strong Buy (dark green). Greyed sources are turned off.
                    </span>
                </div>
            )
        },
        {
            target: ".seventh-step",
            content: (
                <div>
                    <span>
                        <strong>Step 12: Sentiment Trends Over Time</strong>
                        <br />
                        View sentiment and sentiment volume trends over time for
                        each source. Use the toggle buttons to show/hide
                        specific sources on the chart. Click the full-screen
                        icon <img src={fullScreenImg} alt=''></img> for better
                        viewing. Use the technical indicators icon{" "}
                        <img src={stocksImg} alt=''></img> to create advanced
                        sentiment-based technical analysis.
                    </span>
                </div>
            )
        },
        {
            target: ".eight-step",
            content: (
                <div>
                    <span>
                        <strong>Step 13: Document Count</strong>
                        <br />
                        This shows the total number of documents (articles,
                        posts, etc.) returned by your query. For Tesla's S&P 500
                        inclusion, you might see hundreds of news articles and
                        thousands of social media posts analyzed.
                    </span>
                </div>
            )
        },
        {
            target: ".sorting-step",
            content: (
                <div>
                    <span>
                        <strong>Step 14: Sort Your Results</strong>
                        <br />
                        Choose how to sort your documents:
                        <strong>By Relevance</strong> (most relevant to your
                        query),
                        <strong>By Date</strong> (most recent first), or
                        <strong>By Sentiment Score</strong> (highest to lowest
                        sentiment). This helps you focus on the most important
                        or recent information.
                    </span>
                </div>
            )
        },
        {
            target: ".ninth-step",
            content: (
                <div>
                    <span>
                        <strong>Step 15: Review Documents</strong>
                        <br />
                        Browse through the actual documents returned by your
                        query. Each document is color-coded by sentiment: green
                        for positive, red for negative, yellow for neutral. This
                        gives you the raw data behind the sentiment analysis.
                    </span>
                </div>
            )
        },
        {
            target: ".tenth-step",
            content: (
                <div>
                    <span>
                        <strong>Step 16: Download News Data</strong>
                        <br />
                        Export news documents returned by your query to CSV
                        format. This allows you to perform further analysis in
                        Excel or other tools. Useful for creating reports or
                        sharing insights with colleagues.
                    </span>
                </div>
            )
        },
        {
            target: ".eleventh-step",
            content: (
                <div>
                    <span>
                        <strong>Step 17: Download Social Media Data</strong>
                        <br />
                        Export Stocktwits posts returned by your query to CSV
                        format. This includes sentiment scores, timestamps, and
                        post content. Great for tracking social media sentiment
                        trends over time.
                    </span>
                </div>
            )
        },
        {
            target: ".new-step-three",
            content: (
                <div>
                    <span>
                        <strong>Step 18: Trending Dashboards</strong>
                        <br />
                        Access real-time trending dashboards based on sentiment
                        and social buzz. These dashboards show what's currently
                        trending in the market, helping you identify new
                        opportunities or risks.
                    </span>
                </div>
            )
        },

        {
            target: ".twelth-step",
            content: (
                <div>
                    <span>
                        <strong>Step 19: Save Your Query</strong>
                        <br />
                        Save your query for future use. If you modify an
                        existing query, it will be saved with a new version
                        number. This allows you to track how your analysis
                        criteria evolve over time.
                    </span>
                </div>
            )
        },
        {
            target: ".fourteenth-step",
            content: (
                <div>
                    <span>
                        <strong>Step 20: Delete Query</strong>
                        <br />
                        Remove queries you no longer need. This helps keep your
                        query library organized and focused on your current
                        analysis needs.
                    </span>
                </div>
            )
        },
        {
            target: ".thirteenth-step",
            content: (
                <div>
                    <span>
                        <strong>Step 21: Create New Query</strong>
                        <br />
                        Start fresh with a new query using the Query Builder.
                        This clears all current criteria and lets you build a
                        completely new analysis from scratch.
                    </span>
                </div>
            )
        },
        {
            target: ".new-step-four",
            content: (
                <div>
                    <span>
                        <strong>Step 22: About SSi-Research</strong>
                        <br />
                        Learn more about SSi-Research and FinSoftAi. This
                        platform combines advanced AI with financial sentiment
                        analysis to help you make data-driven investment
                        decisions.
                    </span>
                </div>
            )
        },
        {
            target: ".business-value",
            content: (
                <div>
                    <span>
                        <strong>
                            Step 23: Maximizing Your Investment Insights
                        </strong>
                        <br />
                        <strong>Pro Tips:</strong>
                        <br />• <strong>Monitor Key Events:</strong> Track
                        earnings, M&A, product launches, and regulatory changes
                        <br />• <strong>Compare Sources:</strong> News vs Social
                        Media sentiment can reveal different market perspectives
                        <br />• <strong>Track Trends:</strong> Use time-based
                        analysis to spot sentiment shifts before they impact
                        stock prices
                        <br />• <strong>Set Alerts:</strong> Save important
                        queries to monitor ongoing sentiment changes
                        <br />• <strong>Export Data:</strong> Download results
                        for further analysis in Excel or other tools
                    </span>
                </div>
            )
        }
    ])
    const [run, setRun] = useState(false)
    const [stepIndex, setIndex] = useState(0)
    const [newQueryFlag, setFlag] = useState(false)
    const [screensOnDisplay, setDisplayScreens] = useState({
        composite: true,
        piecharts: true,
        graph: true,
        tables: true
    })

    const [DQToggle, setDQToggle] = React.useState("Sentiment_score")

    const [parameterOption, setParameterOptions] = React.useState("general")
    const [portfolios, setPortfolios] = useState([])
    const [selectedPortfolio, setSelectedPortfolio] = useState()

    const handleJoyrideClose = ({ action, index, status, type }) => {
        if (action === "start") {
            setDisplayScreens({
                composite: true,
                piecharts: true,
                graph: true,
                tables: true
            })
        }
        if ([EVENTS.TOUR_END].includes(type) || action === "close") {
            setRun((t) => {
                return false
            })
            setIndex((t) => {
                return 0
            })
        } else if (
            [EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)
        ) {
            // Update state to advance the tour
            setIndex((prevState) => {
                return index + (action === ACTIONS.PREV ? -1 : 1)
            })
        }
        if (action === "close" && type === "step:after") {
            setRun((t) => {
                return false
            })

            fetchScreenLayout()
        }
    }

    const fetchScreenLayout = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_DATA_SERVER_API_URL}/layout/${user.uid}`,
                {
                    headers: { "Access-Control-Allow-Origin": "*" }
                }
            )
            if (response.data.status) {
                setDisplayScreens(JSON.parse(response.data.data.config))
            }
        } catch (err) {
            console.log(err)
        }
    }

    const fetchQueryNames = async () => {
        if (!user) return

        try {
            const resp = await axios.get(
                `${process.env.REACT_APP_DATA_SERVER_API_URL}/query/names/${user.uid}`,
                {
                    headers: {
                        "Access-Control-Allow-Origin": "*",
                        "Access-Control-Allow-Methods": "GET, POST, OPTIONS",
                        "Access-Control-Allow-Headers":
                            "Content-Type, Authorization"
                    }
                }
            )
            return resp.data
        } catch (err) {
            console.log("e", err)
        }
    }

    const populateOptions = async () => {
        let queryNameList = await fetchQueryNames()

        if (!queryNameList.status) return

        let temp = await queryNameList.data.map((query, index) => {
            return (
                <option
                    value={query.query_name + "||" + query.query_version}
                    style={{
                        fontSize: 24,
                        paaddingTop: 2,
                        paddingBottom: 2,
                        fontFamily: "Verdana, Arial",
                        border: "solid 1px red !important"
                    }}>
                    {query.query_name} (v{query.query_version})
                </option>
            )
        })

        setOptions(temp)
    }

    const fetchUserPortfolios = async () => {
        try {
            const resp = await axios.get(
                `${process.env.REACT_APP_DATA_SERVER_API_URL}/portfolio/${user.uid}`,
                { headers: { "Access-Control-Allow-Origin": "*" } }
            )

            if (resp.data.status) {
                let portfolios = resp.data.data

                setPortfolios(portfolios)
                setSelectedPortfolio(portfolios[0])
            }
        } catch (err) {
            console.log(err)
        }
    }

    const handleSelectPortfolio = (name) => {
        const selectedPortfolio = portfolios.find(
            (portfolio) => portfolio.name === name
        )
        setSelectedPortfolio(selectedPortfolio)
    }

    useEffect(() => {
        if (user) {
            populateOptions()
            fetchScreenLayout()
            fetchUserPortfolios()
        }
    }, [user])

    return (
        <div style={{ width: "120% !important", backgroundColor: "white" }}>
            <Joyride
                steps={steps}
                run={run}
                scrollToFirstStep={true}
                showProgress={false}
                continuous={true}
                callback={handleJoyrideClose}
                stepIndex={stepIndex}
                disableCloseOnEsc
                disableOverlayClose
            />
            <Navbar
                queryOptions={queryOptions}
                setOptions={setOptions}
                querySetter={async (data) => {
                    setSavedQuery(data)
                }}
                portfolios={portfolios}
                selectedPortfolio={selectedPortfolio}
                handleSelectPortfolio={handleSelectPortfolio}
                fetchUserPortfolios={fetchUserPortfolios}
                newFlag={async (data) => {
                    setFlag(data)
                }}
                classList={["first-step", "thirteenth-step", "second-step"]}
                setRunHelp={async (data) => {
                    setRun(data)
                }}
                updateQuery={queryModified}
                setUpdates={async (data) => {
                    setModifiedState(data)
                }}
                screensOnDisplay={screensOnDisplay}
                setDisplayScreens={async (data) => {
                    setDisplayScreens(data)
                }}
                dailyModal={modalOpen}
                setDailyModal={async (data) => {
                    setModalOpen(data)
                }}
                parameterFlag={async (data) => {
                    setParameterOptions(data)
                }}
                alertsWeightage={alertsWeightage}
                setAlertsWeightageModalOpen={setAlertsWeightageModalOpen}
            />
            <div
                className='container-fluid business-value'
                style={{ padding: 0, width: "100%" }}>
                <div
                    className='row justify-content-center'
                    style={{ width: "100%", margin: 0, padding: 0 }}>
                    <QueryBuilder
                        classList={["fourth-step", "fifth-step", "sixth-step"]}
                        selectedPortfolio={selectedPortfolio}
                        pieChartsData={async (data) => {
                            setPieChartsData(data)
                        }}
                        compositeSentimentData={async (data) => {
                            setCompositeSentimentData(data)
                        }}
                        newsTableData={async (data) => {
                            setNewsTableData(data)
                        }}
                        stocktwitsTableData={async (data) => {
                            setStocktwitsTableData(data)
                        }}
                        redditTableData={async (data) => {
                            setRedditTableData(data)
                        }}
                        blueskyTableData={async (data) => {
                            setBlueskyTableData(data)
                        }}
                        edgarTableData={async (data) => {
                            setEdgarTableData(data)
                        }}
                        avHicData={async (data) => {
                            setAvHicData(data)
                        }}
                        ibmNewsHicData={async (data) => {
                            setIbmNewsHicData(data)
                        }}
                        stocktwitsHicData={async (data) => {
                            setStocktwitsHicData(data)
                        }}
                        redditHicData={async (data) => {
                            setRedditHicData(data)
                        }}
                        edgarHicData={async (data) => {
                            setEdgarHicData(data)
                        }}
                        blueskyHicData={async (data) => {
                            setBlueskyHicData(data)
                        }}
                        hicData={async (data) => {
                            setHicData(data)
                        }}
                        onChange={(query) => {
                            setQuery(query)
                        }}
                        queryRules={savedQuery}
                        querySetter={async (data) => {
                            setQuery(data)
                        }}
                        viewOnly={false}
                        ticker={async (data) => {
                            setTicker(ticker)
                        }}
                        toggle={async (data) => {
                            setToggle(data)
                        }}
                        DQtoggle={async (data) => {
                            setDQToggle(data)
                        }}
                        setAlertsWeightageModalOpen={async (data) => {
                            setAlertsWeightageModalOpen(data)
                        }}
                        parameterFlag={parameterOption}
                        queryName={queryMeta.name}
                        queryVersion={queryMeta.version}
                        querySector={queryMeta.sector}
                        newFlag={newQueryFlag}
                        prevVersion={queryMeta.prevVersion}
                        setNewFlag={async (data) => {
                            setFlag(data)
                        }}
                        Run={run}
                        setUpdates={async (data) => {
                            setModifiedState(data)
                        }}
                        populateOptions={populateOptions}
                    />
                </div>

                {screensOnDisplay.composite && (
                    <div
                        className='row justify-content-center new-step-two query-results'
                        style={{
                            width: "100% !important",
                            margin: 0,
                            padding: 0
                        }}>
                        <CompositeSent
                            data={compositeSentimentData}
                            newsToggle={newsToggle}
                            setExtWeights={async (data) => {
                                setWeights(data)
                            }}
                        />
                    </div>
                )}

                {screensOnDisplay.piecharts && (
                    <div
                        className='row justify-content-center mt-4 interpretation-help'
                        style={{
                            width: "100%",
                            height: "100%",
                            margin: 0,
                            padding: 0
                        }}>
                        <div
                            className='col-md-auto sixth-step'
                            style={{
                                textAlign: "center",
                                marginRight: 0,
                                padding: 0
                            }}>
                            {/* <PieCharts type="News"  values={pieChartsData.ibm_news?pieChartsData.ibm_news.title:{}}/> */}
                            <PieCharts
                                weights={compWeights}
                                type='News'
                                values={
                                    pieChartsData.ibm_news
                                        ? newsToggle === "title"
                                            ? pieChartsData.ibm_news.title
                                            : pieChartsData.ibm_news.text
                                        : {}
                                }
                            />
                        </div>
                        <div
                            className='col-md-auto'
                            style={{ textAlign: "center", padding: 0 }}>
                            <PieCharts
                                weights={compWeights}
                                type='Stocktwits'
                                values={
                                    pieChartsData.stocktwits
                                        ? pieChartsData.stocktwits
                                        : {}
                                }
                            />
                        </div>
                        <div
                            className='col-md-auto'
                            style={{
                                textAlign: "center",
                                marginRight: 0,
                                padding: 0,
                                pointerEvents: "none"
                            }}>
                            <PieCharts
                                weights={compWeights}
                                type='X-Twitter'
                                values={{}}
                            />
                        </div>
                        <div
                            className='col-md-auto'
                            style={{
                                textAlign: "center",
                                marginRight: 0,
                                padding: 0
                            }}>
                            <PieCharts
                                type='Reddit'
                                values={
                                    pieChartsData.reddit
                                        ? pieChartsData.reddit
                                        : {}
                                }
                            />
                        </div>
                        <div
                            className='col-md-auto'
                            style={{
                                textAlign: "center",
                                padding: 0,
                                pointerEvents: "none"
                            }}>
                            <PieCharts
                                weights={compWeights}
                                type='Trends'
                                values={{}}
                            />
                        </div>
                        <div
                            className='col-md-auto'
                            style={{ textAlign: "center", padding: 0 }}>
                            <PieCharts
                                weights={compWeights}
                                type='Third Party'
                                values={
                                    pieChartsData.third_party
                                        ? pieChartsData.third_party
                                        : {}
                                }
                            />
                        </div>
                        <div
                            className='col-md-auto'
                            style={{
                                textAlign: "center",
                                padding: 0,
                                pointerEvents: isTrialUser ? "none" : "auto",
                                opacity: isTrialUser ? 0.5 : 1
                            }}>
                            <Tooltip
                                title={
                                    isTrialUser
                                        ? "Premium feature - Upgrade to access Edgar data"
                                        : ""
                                }
                                placement='top'
                                arrow>
                                <div>
                                    <PieCharts
                                        weights={compWeights}
                                        type='Edgar'
                                        values={
                                            pieChartsData.edgar
                                                ? pieChartsData.edgar
                                                : {}
                                        }
                                    />
                                </div>
                            </Tooltip>
                        </div>
                        <div
                            className='col-md-auto'
                            style={{
                                textAlign: "center",
                                marginRight: 0,
                                padding: 0,
                                pointerEvents: isTrialUser ? "none" : "auto",
                                opacity: isTrialUser ? 0.5 : 1
                            }}>
                            <Tooltip
                                title={
                                    isTrialUser
                                        ? "Premium feature - Upgrade to access Bluesky data"
                                        : ""
                                }
                                placement='top'
                                arrow>
                                <div>
                                    <PieCharts
                                        weights={compWeights}
                                        type='Bluesky'
                                        values={
                                            pieChartsData.bluesky
                                                ? pieChartsData.bluesky
                                                : {}
                                        }
                                    />
                                </div>
                            </Tooltip>
                        </div>
                    </div>
                )}

                <hr></hr>
                {screensOnDisplay.graph && (
                    <div className='seventh-step'>
                        <Graphs
                            avData={avHicData}
                            newsData={ibmNewsHicData}
                            stocktwitsData={stocktwitsHicData}
                            redditData={redditHicData}
                            blueskyData={blueskyHicData}
                            edgarData={edgarHicData}
                            data={hicData}
                            newsToggle={newsToggle}
                            query={savedQuery}
                        />
                    </div>
                )}

                <hr></hr>
                {screensOnDisplay.tables && (
                    <div>
                        <Tables
                            newsData={newsTableData}
                            Run={run}
                            stocktwitsData={stocktwitsTableData}
                            DQToggle={DQToggle}
                            redditData={redditTableData}
                            blueskyData={blueskyTableData}
                            newsToggle={newsToggle}
                            edgarData={edgarTableData}
                            query={query}
                        />
                    </div>
                )}
                <Footer></Footer>
            </div>

            <FContainer
                className='new-step-three'
                styles={{
                    margin: 0,
                    top: "auto",
                    right: 20,
                    bottom: 20,
                    left: "auto",
                    position: "fixed"
                }}>
                <FButton
                    tooltip='Click to open Daily Graphs'
                    // icon={}
                    styles={{
                        backgroundColor: "#f9ce1b",
                        color: "#3d3d3d",
                        padding: 2,
                        boxShadow: "3px 4px rgba(203,203,203,0.6)"
                    }}
                    rotate={false}
                    onClick={() =>
                        setModalOpen(() => {
                            return true
                        })
                    }>
                    <CandlestickChartIcon fontSize='large' />
                </FButton>
            </FContainer>
        </div>
    )
}

export default OurApp
